import React from "react";
import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { daysOfWeek } from "../../../constants/string";

const OperationalDays = ({ operationalDays, setOperationalDays }) => (
  <Box my={1}>
    <Typography variant="h6" gutterBottom align="left">
      Store Operational Days
    </Typography>
    <Box sx={{ textAlign: "left" }}>
      {daysOfWeek.map((day) => (
        <FormControlLabel
          key={day}
          control={
            <Checkbox
              checked={operationalDays.includes(day)}
              onChange={(e) => {
                const updatedDays = e.target.checked
                  ? [...operationalDays, day]
                  : operationalDays.filter((d) => d !== day);
                setOperationalDays(updatedDays.join(","));
              }}
            />
          }
          label={day}
          sx={{ textAlign: "left" }}
        />
      ))}
    </Box>
  </Box>
);

export default OperationalDays;
